/**
 * index.jsx
 *
 * @Author: wangyinan
 * @Date: 2018/3/29 下午4:01
 */

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { Transition } from 'react-transition-group';
import Header from '../common/header/header';
import Footer from '../common/footer';
import ajax from './util/ajax';
import action from '../reduxModules/action';
import RouterConfig from './router';
import { Modal } from 'neatui/es/index.mobile';
import './index.scss';

class Index extends React.PureComponent {
  static propTypes = {};

  static defaultProps = {};

  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: true,
    };
    // 适配上帝视角
    // const router = props.router;
    // this.searchObj = {};
    // if (router.location.search) {
    //     router.location.search.match(/(\w+=[^&=?]+)(?=&|)/g).forEach(item => {
    //         let rs = item.split('=');
    //         this.searchObj[rs[0]] = rs[1];
    //     });
    // }
    // if (this.searchObj.wemediaId) {
    //     defaultParams['wemediaId'] = this.searchObj.wemediaId;
    // }
  }

  componentDidMount() {
    // this.jumpHttp('https', 'http');
    this.getNavinfo().then(() => {
      this.setState({
        loading: true,
      });
    });
  }

  jumpHttp(from, to) {
    const { href, protocol } = window.location;
    const regex = new RegExp(`^${from}`);
    if (protocol === `${from}:`) window.location.replace(href.replace(regex, to));
  }

  getNavinfo = () => {
    const { updateCommon } = this.props;
    // const that = this;

    return ajax(
      '/navinfo.do',
      {},
      rs => {
        updateCommon('user', rs.data);
        if (rs.code == '100030') {
          Modal.warning({
            title: '提示',
            vertical: 'middle',
            content:
              '长时间未登录，信息已失效，为了保证帐号安全，请验证手机号信息。如原手机无法自行换绑，请提交材料申请修改手机号。',
          });
        }
        return rs;
      },
      rs => rs,
      false,
      false,
      false,
    ).then((res) => {
      if (res.code === 100021) {
        window.location.href = `/login.html#/`;
      }
      // const { stone, router, pushHistory } = this.props;
      // const { location } = router;
      // if (!that.searchObj.wemediaId) {
      //     pushHistory(
      //         deepCopy({}, location, {
      //             search:
      //                 location.search +
      //                 (location.search === '' ? '?' : '&') +
      //                 `wemediaId=${stone.user.wemediaId}`,
      //         }),
      //     );
      //     that.searchObj.wemediaId = stone.user.wemediaId;
      //     if (that.searchObj.wemediaId) {
      //         defaultParams['wemediaId'] = this.searchObj.wemediaId;
      //     }
      // }
    });
  };

  render() {
    const { stone, router } = this.props;
    const { loading } = this.state;
    return (
      <Transition timeout={500} in={loading}>
        {status => (
          <Fragment>
            <Header
              className={`header slideDown slideDown-${status}`}
              updateState={this.getNavinfo}
              msgProjectLink={`/index.html#/message${router.location.search}`}
              {...stone.user}
            />
            <div className={`content fadeIn fadeIn-${status}`}>
              <RouterConfig location={router.location} userInfo={stone.user} is="mcn" />
            </div>
            <Footer />
          </Fragment>
        )}
      </Transition>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      stone: state.common,
      router: state.router,
    }),
    dispatch =>
      bindActionCreators(
        {
          updateCommon: action.updateCommon,
          pushHistory: push,
        },
        dispatch,
      ),
  )(Index),
);
